import { type User, UserSchema } from '@scoring/types';
import { useApiMutation } from '../../queries/useApiMutation';
import { produce } from 'immer';
import { queryKeys } from '../../queries/queryKeys';
import { setQueryDataSafe } from '../../utils/queryUtilities';
import { post } from '../../queries';
import z from 'zod';

export const CreateUserRequestSchema = UserSchema.omit({ id: true, profilePictureImageId: true }).required({
    password: true,
});

const CreateUserResponseSchema = z.uuid();

export type CreateUserRequest = z.infer<typeof CreateUserRequestSchema>;
export type CreateUserResponse = z.infer<typeof CreateUserResponseSchema>;

export const useCreateUserMutation = () => {
    const mutation = useApiMutation<{ user: CreateUserRequest }, CreateUserResponse, User>({
        mutationFn: ({ user }) => post('users', user, CreateUserResponseSchema),

        transform: (response, variables) => ({
            ...variables.user,
            id: response,
        }),

        onManualCacheUpdate: (queryClient, response) => {
            setQueryDataSafe<User[]>(queryClient, queryKeys.users.list(), (previous) =>
                produce(previous, (draft) => {
                    draft.push(response);
                })
            );
        },
    });

    return mutation;
};
